module.exports = __webpack_public_path__ + "img/rm_4.693097cf.png";